<template>
  <basic-container class="paymentPageConfig">
    <div class="head">
      <el-select v-model="searchParams.sourceKey"
                 clearable
                 @change="()=>{
                    searchParams.current = 1
                    loadList()
                  }"
                 placeholder="请选择入口来源">
        <el-option v-for="item in paySourceListOptions"
                   :key="item.sourceKey"
                   :label="item.name"
                   :value="item.sourceKey">
        </el-option>
      </el-select>
      <div class="btn_box">
        <el-button type="primary"
                   v-auth="'memberNew_paymentPageConfig_index_search'"
                   icon="el-icon-search"
                   @click="()=>{
                    searchParams.current = 1
                    loadList()
                  }">搜索</el-button>
        <el-button type="primary"
                   v-auth="'memberNew_paymentPageConfig_index_add'"
                   plain
                   icon="el-icon-plus"
                   @click="()=>{itemDetails={}; editDialog=true}">新增</el-button>
        <el-button type="danger"
                   v-auth="'memberNew_paymentPageConfig_index_delete'"
                   plain
                   icon="el-icon-delete"
                   @click="handleDelete(multipleSelection)">删除</el-button>
      </div>

    </div>
    <el-table ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection"
                       width="75">
      </el-table-column>
      <el-table-column label="ID"
                       width="55"
                       prop="id">

      </el-table-column>
      <el-table-column prop="memberPayConfigTypeList"
                       label="会员类型">
        <template slot-scope="scope">{{ Array.isArray(scope.row.memberPayConfigTypeList) && scope.row.memberPayConfigTypeList.length && (scope.row.memberPayConfigTypeList.map(item=> {return item.memberTypeName}).join(','))}}</template>
      </el-table-column>
      <el-table-column prop="defaultMemberTypeName"
                       label="默认选中会员"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="memberPayConfigSourceList"
                       label="入口来源"
                       show-overflow-tooltip>
        <template slot-scope="scope">{{ Array.isArray(scope.row.memberPayConfigSourceList) && scope.row.memberPayConfigSourceList.length && (scope.row.memberPayConfigSourceList.map(item=> {return item.paySourceName}).join(','))}}</template>

      </el-table-column>
      <el-table-column prop="channelName"
                       label="渠道配置"
                       show-overflow-tooltip>
        <template slot-scope="scope">{{ showChannelList(scope.row.memberPayConfigChannelList)  }}</template>
      </el-table-column>
      <el-table-column
        prop="tvVersion"
        label="版本配置"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-for="(item, index) in getVersionConfigText(scope.row)" :key="index">
            <div v-if="item">{{ item }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     v-auth="'memberNew_paymentPageConfig_index_log'"
                     @click="openLog(scope.$index, scope.row)">查看日志</el-button>
          <el-button type="text"
                     v-auth="'memberNew_paymentPageConfig_index_edit'"
                     @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text"
                     v-auth="'memberNew_paymentPageConfig_index_delete'"
                     @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ElementPagination style="margin-bottom: 20px;"
                       :current-page="searchParams.current"
                       :page-size="searchParams.size"
                       :total="searchParams.total"
                       :page-sizes="[10, 20, 30, 40, 50]"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" />
    <!-- 查看日志对话框- -->
    <logDialog :logDialog.sync="logDialog"
               :source="'2'"
               :id.sync="logId"></logDialog>
    <addDialog :details="itemDetails"
               :addDialogVisible.sync="editDialog"
               @closeDialogVisible="()=>{
                editDialog=false
                loadList()
              }"></addDialog>
  </basic-container>
</template>

<script>
import logDialog from "../components/memberRightLog.vue";
import addDialog from "./addDialog.vue";
import ElementPagination from "@/components/ElementPagination";
import { configPage, configDelByIds, paySourceList } from '@/api/memberNew/paymentPageConfig'
import { getVersionConfigText } from "./utils/useTvVersion";
export default {
  name: 'paymentPageConfig',
  components: {
    logDialog,
    addDialog,
    ElementPagination
  },
  data () {
    return {
      itemDetails: {},
      paySourceListOptions: [], //入口来源选项
      tableData: [],
      multipleSelection: '',
      /** 日志的id */
      logId: "",
      /** 编辑对话框的显隐 */
      editDialog: false,
      /** 查看日志对话框的显隐 */
      logDialog: false,
      /** 搜索参数 */
      searchParams: {
        current: 1,
        size: 10,

      },
    }
  },
  created () {
    this.loadList()
    this.init()
  },
  methods: {
    getVersionConfigText,
    showChannelList (list) {
      if (Array.isArray(list) && list.length) {
        let nameList = list.map(item => { return item.channelId == 0 ? item.channelName : item.channelName + '(' + item.channelId + ')' })
        return nameList.join(',')
      } else {
        return ''
      }
    },
    // 初始化页面数据
    async init () {
      try {
        let paySourceListData = await paySourceList()
        this.paySourceListOptions = paySourceListData.data.data || []
      } catch (error) {
        this.defaultMemberTypeIdOption = []
      }
    },
    // 日志
    openLog (id) {
      console.log(this.logDialog);
      /** 把id传过去 */
      this.logId = id;
      this.logDialog = true;
    },
    // 多选数据
    handleSelectionChange (val) {
      if (val.length) {
        let ids = val.map(item => item.id)
        this.multipleSelection = ids.join(',');
      } else {
        this.multipleSelection = ''
      }
    },
    // 编辑
    handleEdit (data) {
      this.editDialog = true
      console.log(data);
      this.itemDetails = data
    },
    // 删除
    handleDelete (id) {
      if (!id) {
        this.$message({
          type: 'error',
          message: '请选择要删除的数据!'
        });
        return
      }

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let { data } = await configDelByIds({ ids: id })
        if (data.code === 200) {
          this.loadList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });



    },/** 每页条数change */
    handleSizeChange (val) {
      this.searchParams.current = 1;
      this.searchParams.size = val;
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange (val) {
      this.searchParams.current = val;
      /** 更新数据 */
      this.loadList();
    },
    // 删除空健
    removeEmptyValue (obj) {
      // 获取对象的所有值
      const values = Object.values(obj);
      // 遍历所有值
      for (const value of values) {
        // 判断值是否为空
        if (!value) {
          // 获取需要删除的键
          const keys = Object.keys(obj);
          // 遍历所有键
          for (const key of keys) {
            // 删除指定键的属性
            delete obj[key];
          }
          break; // 可以根据需求选择是否终止循环
        }
      }
      return obj;
    },

    // 查询列表
    async loadList () {
      let params = {
        ...this.searchParams
      }

      let { data } = await configPage(params)
      console.log('查询列表data', data)
      if (data && data.data) {
        this.tableData = data.data.records
        this.searchParams.total = data.data.total;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paymentPageConfig {
  .head {
    display: flex;
    justify-content: space-between;
    padding: 12px 0 24px;
  }
}
</style>
